<template>
  <v-content>
    <v-row>
      <v-col cols="2">
        <v-dialog
          v-model="dialogVisible"
          width="clamp(500px, 700px, 900px)"
        >
          <v-card>
            <v-list dense>
              <v-subheader class="display-2">
                Выберите организацию
              </v-subheader>
              <v-divider />
              <v-list-item-group
                v-model="selectedItem"
                color="primary"
                @change="onChooseItem"
              >
                <v-list-item
                  v-for="(item) in customers"
                  :key="item.value"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <router-view />
    <snackbar /> <!-- for loyalty -->

    <div class="my-12" />

    <dashboard-core-footer />
  </v-content>
</template>
<style scoped>
.header-notification {
  top: 93px;
  width: calc(100% - 24px);
  margin: 12px 12px 6px;
  padding: 8px 16px;
  align-items: center;
  background-color: rgb(33,150,243);
  border-radius: 4px;
  display: flex;

  transition: inherit;
  transition-property: opacity, transform;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);

    justify-content: flex-start;
    overflow: hidden;

}
.header-notification .hn-icon {
  padding-right: 8px;
}
.header-notification .hn-text {
  color: white;
  font-size: 14px;
  text-shadow: 1px 1px 2px #315bbf, 0 0 1em #315bbf;
}

</style>
<script>
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"

export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
      Snackbar: () => import('@/views/loyalty/shared/components/snackbar/Snackbar'), // for loyalty
      ItemList: () => import('@/views/loyalty/shared/components/item-list/ItemList')
    },
    data: () => ({
      customers: [{ value: '', text: '' }],
      dialogVisible: false,
      justpayClient: null,
      selectedItem: 0,
        userprofileService: null,
    }),
    async beforeMount () {
      // console.clear()
      const userProfileId = localStock.getItem('userProfile').userProfileId
      const customerId = localStorage.getItem('customer')
      /* this.justpayClient = new JustpayClient() */
      /* this.userprofileService = new Userprofile() */
      /* if (customerId) {
        const customerShortName = await this.justpayClient.getClientShortName(customerId)
        console.log('customerShortName:', customerShortName)
        this.$emit('changeCompanyName', customerShortName)
        return
      } */
      /* const customerNumbers = await this.userprofileService.getCustomerNumbers(userProfileId)
      console.log('customerNumbers:', customerNumbers)
      if (customerNumbers.length === 1) {
         const customer = await this.justpayClient.getClientByNumber(customerNumbers[0])
        localStorage.setItem('customer', customer.id)
          localStorage.setItem('customerNumber', customerNumbers[0])
        this.dialogVisible = false
      } else {
           this.dialogVisible = true
          this.customers = await Promise.all(customerNumbers.map(async customerNumber => {
            return this.justpayClient.getClient(customerNumber)
          }))
          console.log('this.customers:', this.customers)
      } */
    },
    methods: {
      async onChooseItem () {
        if (this.selectedItem !== undefined) {
          console.log('this.selectedItem=' + this.selectedItem)
          console.log('customer=', this.customers[this.selectedItem].value)
          /* localStorage.setItem('customer', this.customers[this.selectedItem].value)
          const customerNumber = await this.justpayClient.getClientNumber(this.customers[this.selectedItem].value)
          localStorage.setItem('customerNumber', customerNumber) */
          this.dialogVisible = false
        }
      }
    },
  }
</script>
